import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Tooltip,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useRef, useState, useMemo } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import UploadFileTwoToneIcon from "@mui/icons-material/UploadFileTwoTone";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
import { editDeleteSupplier, getSupplierList, addImportSupplier } from "../../../actions/actions";
import HeaderSection from "../../reusableComponent/HeaderSection";
import * as XLSX from "xlsx";
import supplierMasterService from "../../../services/masters/supplierMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import CustomPagination from "../../reusableComponent/CustomPagination";

const SupplierList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem("loginUser");
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  // Redux state selectors
  const totalCount = useSelector((state) => state.supplier.total_count || 0);
  const defaultRowsPerPage = useSelector((state) => state.supplier.rows_per_page || 15);
  // const rows = useSelector((state) => state.supplier.supplier);
  const [rows, setRows] = useState([]);
  const respMsgState = useSelector((state) => state.supplier.message);

  // Local state
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const [fileUploadError, setFileUploadError] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [lastUploadedFile, setLastUploadedFile] = useState(null);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  // Update rowsPerPage when defaultRowsPerPage changes
  useEffect(() => {
    setController((prev) => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const fields = ["supplier_name", "mobile_no", "account_number", "contact_person", "supplier_address", "gstn"];
  const labels = ["Supplier Name", "Mobile No", "Account Number", "Contact Person", "Supplier Address", "GSTN"];

  const fileInputRef = useRef(null);

  // Fetch supplier data
  // const fetchData = () => {
  //   const params = {
  //     page: controller.page,
  //     size: controller.rowsPerPage,
  //     searchKey: searchKey,
  //   };
  //   dispatch(getSupplierList(params));
  // };
  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await supplierMasterService.getSupplierList(params);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller, totalCount]);

  // Handle success messages
  // useEffect(() => {
  //   if (respMsgState) {
  //     setSuccessMessage(respMsgState);
  //   }
  // }, [respMsgState]);

  // const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData, null, setSuccessMessage, respMsgState);

  // useEffect(() => { }, [shouldShowMsg, responseMessage]);

  // Handle pagination
  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  // Handle search
  // const handleSearch = (e) => {
  //   setSearchKey(e.target.value);
  //   const params = {
  //     page: controller.page,
  //     size: e.target.value === "" ? controller.rowsPerPage : totalCount,
  //     searchKey: e.target.value,
  //   };
  //   dispatch(getSupplierList(params));
  // };
  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);  // Set the search key
    
    // Prepare the params based on the search value
    const params = {
        page: controller.page,
        size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
        searchKey: searchValue,
    };

    try {
        // Fetch data using the fetchData function (assuming fetchData is already declared)
        await fetchData(params);
    } catch (error) {
        console.error("Error in handleSearch:", error);
    }
};

  // Download template
  const downloadTemplate = () => {
    const templateData = [{
      "Supplier Name": "",
      "Mobile No": "",
      "Account Number": "",
      "Contact Person": "",
      "Supplier Address": "",
      "GSTN": ""
    }];
    const ws = XLSX.utils.json_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Template");
    XLSX.write(wb, "Supplier_Upload_Template.xlsx");
  };

  // Handle file upload
  const handleUpload = () => {
    console.log("handleUpload called, fileInputRef:", fileInputRef.current);
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.error("fileInputRef is null");
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setFileUploadError("");
    setSuccessMessage("");
    setIsUploading(true);
    setLastUploadedFile(file);

    if (!file) {
      setIsUploading(false);
      return;
    }

    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (!["xlsx", "xls", "csv"].includes(fileExtension)) {
      setFileUploadError("Please upload a valid Excel file (.xlsx, .xls, or .csv)");
      setIsUploading(false);
      return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
      try {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);

        if (jsonData.length === 0) {
          setFileUploadError("The uploaded file contains no data.");
          setIsUploading(false);
          return;
        }

        // Map data without validation, keep blank fields as ""
        const processedData = jsonData.map((row, index) => ({
          rowIndex: index + 2, // For error reporting
          supplier_name: row["Supplier Name"] ? String(row["Supplier Name"]).trim() : "",
          mobile_no: row["Mobile No"] ? String(row["Mobile No"]).trim() : "",
          account_number: row["Account Number"] ? String(row["Account Number"]).trim() : "",
          contact_person: row["Contact Person"] ? String(row["Contact Person"]).trim() : "",
          supplier_address: row["Supplier Address"] ? String(row["Supplier Address"]).trim() : "",
          gstn: row["GSTN"] ? String(row["GSTN"]).trim() : "",
        }));

        console.log("Processed Data:", processedData);

        // Dispatch all rows to backend
        try {
          const response = await dispatch(addImportSupplier({ suppliers: processedData.map(({ rowIndex, ...data }) => data) })).unwrap();
          setSuccessMessage(
            response.skipped > 0
              ? `Imported ${response.imported} records. Skipped ${response.skipped} duplicates: ${response.skippedDetails?.join(", ") || "Unknown"}`
              : `Successfully imported ${processedData.length} supplier records.`
          );
          fetchData(); // Refresh table data
        } catch (error) {
          console.error("Backend error:", {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data,
            headers: error.response?.headers,
          });
          let errorMessage = "Failed to process the file. Please check the data or contact support.";
          if (error.response?.data) {
            if (error.response.data.message) {
              errorMessage = error.response.data.message;
            } else if (error.response.data.error) {
              errorMessage = error.response.data.error;
            } else if (error.response.data.details) {
              errorMessage = error.response.data.details.join("\n");
            } else {
              errorMessage = JSON.stringify(error.response.data);
            }
          } else if (error.message.includes("Network Error")) {
            errorMessage = (
              <Box>
                Network error. Please check your internet connection and try again.
                {lastUploadedFile && (
                  <Button
                    onClick={() => handleFileChange({ target: { files: [lastUploadedFile] } })}
                    size="small"
                    sx={{ ml: 1 }}
                  >
                    Retry
                  </Button>
                )}
              </Box>
            );
          }
          setFileUploadError(errorMessage);
        }
      } catch (error) {
        console.error("Import error:", error);
        setFileUploadError("Failed to parse the file. Please ensure it is a valid Excel/CSV file.");
      }
      e.target.value = null;
      setIsUploading(false);
    };

    reader.readAsArrayBuffer(file);
  };

  // Handle delete
  // const deleteRecord = (id) => {
  //   dispatch(editDeleteSupplier({ supplier_id: id, changedUpdatedValue: "delete" }));
  //   setIsDelete(false);
  //   fetchData();
  // };

  const deleteRecord = async (id) => {
    try {
      await supplierMasterService.editDeleteSupplier({
        supplier_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  // Memoized sorted rows
  const sortedRows = useMemo(() => {
    return [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  }, [rows]);

  // Pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb routeSegments={[{ name: "Supplier List" }]} />

        <HeaderSection
          title="SUPPLIER LIST"
          addNewPath="/masters/add-supplier"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Supplier List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        // showUploadButton={true}
        // onUploadClick={handleUpload}
        />

        <Paper sx={{ width: '100%',  }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}
                    onClick={() => HandleSort("supplier_name", sortBy, setSortBy, rows)}
                    sx={{width:'30%'}}
                  >
                    Supplier Name
                    <span className={`${styles.sort_icon}`}>
                      {sortBy === "supplier_name" ? "▲" : "▼"}
                    </span>
                  </StyledTableCell>


                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`} >City </StyledTableCell>


                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`}>
                    State </StyledTableCell>


                  <StyledTableCell
                    align="left"
                    className={`${styles.table_head}`} >
                    Contact Person  </StyledTableCell>




                  <StyledTableCell
                   align="left"
                    className={`${styles.table_head}`}>
                    Mobile No </StyledTableCell>
                    
                  <StyledTableCell align="center" className={`${styles.table_head}`}>
                    Action
                  </StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) &&
                  rows.map((row) => (
                    <StyledTableRow
                      key={row.supplier_id}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>

                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.supplier_name}
                      </StyledTableCell>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.city}
                      </StyledTableCell>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.state}
                      </StyledTableCell>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.contact_person}
                      </StyledTableCell>
                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                        {row.mobile_no}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomePopover
                          row={row}
                          handleDelete={false}
                          linkTo="/masters/add-supplier"
                          handlePrint ={false}
                             handleCancel={false}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
                     <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.supplier_id || null}
          displayName={deleteInfo?.supplier_id || ""}
        />

        <ReusableSnackbar
          open={!!successMessage || !!fileUploadError}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              HandleCloseSnackbar(event, reason, setSuccessMessage);
              setFileUploadError("");
            }
          }}
          message={successMessage || fileUploadError}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />



        
      </Box>
    </Box>
  );
};

export default SupplierList;